module.exports = __webpack_public_path__ + "static/img/bg14.16363ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg14.jpg
// module id = 26jh
// module chunks = 1